import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { RemoveJobComponent } from './remove-job.component';



@NgModule({
  declarations: [
    RemoveJobComponent
  ],
  imports: [
    SharedModule,
    CommonModule
  ],
  exports: [
    RemoveJobComponent
  ]
})
export class RemoveJobModule { }
